import accounts from './accounts.es';
import businessTypes from './business-types.es';
import contactLanguages from './contact-languages.es';
import countries from './countries.es';
import crud from './crud.es';
import documents from './documents.es';
import filters from './filters.es';
import general from './general.es';
import headers from './headers.es';
import interveners from './interveners.es';
import issues from './issues.es';
import maritalStatus from './marital-status.es';
import matrimonialRegime from './matrimonial-regime.es';
import operations from './operations.es';
import permissions from './permissions.es';
import polls from './polls.es';
import spanishProvinces from './spanish-provinces.es';
import spanishStates from './spanish-states.es';
import streetTypes from './street-types.es';
import importer from './importer.es';

export default {
    accounts,
    countries,
    crud,
    documents,
    general,
    headers,
    interveners,
    issues,
    operations,
    permissions,
    polls,
    spanishProvinces,
    spanishStates,
    streetTypes,
    maritalStatus,
    matrimonialRegime,
    contactLanguages,
    businessTypes,
    filters,
    importer
};
